import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-employee-viewer',
  templateUrl: './employee-viewer.component.html',
  styleUrls: ['./employee-viewer.component.scss']
})
export class EmployeeViewerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
